import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const CardHeaderTitle = ({ variant = 'default', className, ...props }) => {
  return (
    <h1
      className={clsx(
        'leading-tight font-bold text-gray-900 pt-[2px]',
        className,
        {
          'text-base font-semibold': variant === 'card',
          'text-2xl': variant === 'root',
          'text-xl mb-2': variant === 'default',
        },
      )}
      {...props}
    />
  );
};

CardHeaderTitle.propTypes = {
  variant: PropTypes.oneOf(['root', 'card', 'default']),
};

export default CardHeaderTitle;
